import { GetOrderUspsLabelState } from './getOrderUspsLabel.types'

export const getOrderUspsLabelInitialState: GetOrderUspsLabelState = {
  loading: false,
  error: null,
  success: null
}

export default getOrderUspsLabelInitialState
